<template>
<div>
  <my-header></my-header>
  
    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <h2>Push notification (id {{pushId}})</h2>
        <router-view></router-view>
      </div>
    </div>
</div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'Push',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    pushId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menuItems() {
      return [
        {
          title: 'Info',
            route: {name: 'push_info', params: {pushId: this.pushId}},
        },
        {
          title: 'Jobs',
          route: {name: 'push_jobs', params: {pushId: this.pushId}},
        },
      ];
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
  margin-bottom: 1rem;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
  padding-top: 1em;
}
</style>